import disclaimersLabels from './disclaimers';

const allAccolades = [
  'consulting_reports_top_50_consulting_firms',
  'forbes_worlds_best_management_consulting_firms',
  'HFS_generative_enterprise_services_market_leader_2023',
  'idc_marketScape_for_worldwide_experience_design_2023_24',
  'e_footprint',
  'google_cloud_partner_of_the_year_2024',
  'VivaTech_2024',
  'disability_confident_employer',
  'guide_to_next',
  'consulting_magazine_best_firms_to_work_for_2023',
  'Consultancy_uk_Top_Consulting_Firms_in_UK_2023',
  'consulting_report_top_consulting_firm_2023',
  'carbon_markets',
  'get_ahead_cp',
  'seize_the_space_t_h',
  'vault_emea',
  'vault_north_america',
  'vault_apac',
  'workingwithcancer',
  'great_place_to_work_germany',
  'great_place_to_work_us',
  'iDBT',
  'consulting_magazine_best_firms',
  'school_of_next',
  'forbes_best_consulting_firms',
  'egalite',
  'shopper_first_retail',
  'uk_financial_times',
  'human_rights_campaign',
  'energy_tech_awards',
  'tech_women',
  // 'the_how_channel', // temporarily removed from the "Create your signature" accolades list
  'enable',
  'gartner_peer_insights',
  'idc_marketscape_2',
  'gartner_topscorercx',
  'gartner_magic_quadrant',
  'vault_top_ranked_internship_program_2025',
  'vault_top_ranked_internship_program_lgbtq_2025',
  'wiwo_best_of_consulting_award_2024',
  'VivaTech_2025'
];

const indiaAccolades = [
  'consulting_reports_top_50_consulting_firms',
  'forbes_worlds_best_management_consulting_firms',
  'HFS_generative_enterprise_services_market_leader_2023',
  'idc_marketScape_for_worldwide_experience_design_2023_24',
  'e_footprint',
  'google_cloud_partner_of_the_year_2024',
  'VivaTech_2024',
  'business_disability_forum_member',
  'guide_to_next',
  'consulting_magazine_best_firms_to_work_for_2023',
  'Consultancy_uk_Top_Consulting_Firms_in_UK_2023',
  'consulting_report_top_consulting_firm_2023',
  'carbon_markets',
  'get_ahead_cp',
  'seize_the_space_t_h',
  'vault_emea',
  'vault_north_america',
  'vault_apac',
  'workingwithcancer',
  'great_place_to_work_germany',
  'great_place_to_work_us',
  'iDBT',
  'consulting_magazine_best_firms',
  'school_of_next',
  'forbes_best_consulting_firms',
  'egalite',
  'shopper_first_retail',
  'uk_financial_times',
  'human_rights_campaign',
  'energy_tech_awards',
  'tech_women',
  'certified_great_place',
  // 'the_how_channel', // temporarily removed from the "Create your signature" accolades list
  'enable',
  'gartner_peer_insights',
  'idc_marketscape_2',
  'gartner_topscorercx',
  'gartner_magic_quadrant',
  'vault_top_ranked_internship_program_2025',
  'vault_top_ranked_internship_program_lgbtq_2025',
  'wiwo_best_of_consulting_award_2024',
  'VivaTech_2025'
];

const germanyAccolades = [
  'consulting_reports_top_50_consulting_firms',
  'forbes_worlds_best_management_consulting_firms',
  'HFS_generative_enterprise_services_market_leader_2023',
  'idc_marketScape_for_worldwide_experience_design_2023_24',
  'e_footprint',
  'google_cloud_partner_of_the_year_2024',
  'VivaTech_2024',
  'business_disability_forum_member',
  'guide_to_next',
  'consulting_magazine_best_firms_to_work_for_2023',
  'Consultancy_uk_Top_Consulting_Firms_in_UK_2023',
  'consulting_report_top_consulting_firm_2023',
  'carbon_markets',
  'get_ahead_cp',
  'seize_the_space_t_h',
  'vault_emea',
  'vault_north_america',
  'vault_apac',
  'workingwithcancer',
  'great_place_to_work_germany',
  'great_place_to_work_us',
  'iDBT',
  'consulting_magazine_best_firms',
  'school_of_next',
  'forbes_best_consulting_firms',
  'egalite',
  'shopper_first_retail',
  'uk_financial_times',
  'human_rights_campaign',
  'energy_tech_awards',
  'tech_women',
  'gptw_germany',
  // 'the_how_channel', // temporarily removed from the "Create your signature" accolades list
  'enable',
  'gartner_peer_insights',
  'idc_marketscape_2',
  'gartner_topscorercx',
  'gartner_magic_quadrant',
  'vault_top_ranked_internship_program_2025',
  'vault_top_ranked_internship_program_lgbtq_2025',
  'wiwo_best_of_consulting_award_2024',
  'VivaTech_2025'
];


const officeLabels = {
  'atlanta': {
    iso: 'us',
    location: 'Atlanta',
    address: '384 Northyards, Suite 210<br/>Atlanta, GA 30313',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'beijing': {
    iso: 'cn',
    location: 'Beijing',
    address: 'Tower B-1503 & 04, Lei Shing Hong Plaza<br/>No. 8 Wangjing Street, Chaoyang District<br/>Beijing, China 100102',
    accolades: allAccolades,
  },
  'belgrade':{
    iso: 'rs',
    location: 'Belgrade ',
    address: 'Bulevar Zorana Đinđića 144 A <br> Beograd 11000, Serbia',
    accolades: allAccolades,
 },
 'bengaluru' : {
    iso: 'in',
    location: 'Bengaluru',
    address: '2870, Building - Virgo<br/>Bagmane Constellation Business Park<br/>Outer Ring Road, Doddanekundi Circle<br/>Marathahalli Post Bengaluru<br/>560037 Karnataka, India',
    accolades: indiaAccolades,
  },
  'berlin': {
    iso: 'de',
    location: 'Berlin',
    address: 'Sapient GmbH<br/> Leibnizstraße 65<br/>10629 Berlin, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'bogota':{
    iso: 'CO',
    location: 'Bogota',
    address: 'Calle 93b No.13-44.<br/>Bogota 110221, Colombia<br/>Tel: +57 6017449080',
    accolades: allAccolades,

  },
  'boston': {
    iso: 'us',
    location: 'Boston',
    address: '40 Water Street<br/>Boston, MA 02109',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'brasov': {
    iso: 'ro',
    location: 'Brasov',
    address: 'Coresi Business Camp,<br/>5 Turnului street,<br/>N2 Office,<br/>Brașov 500152',
    accolades: allAccolades,
  },
  'bucharest': {
    iso: 'ro',
    location: 'Bucharest',
    address: 'Victoriei Square, 47-53 Lascar Catargiu,<br/>Europe House, 7th floor, 010665 Bucharest<br/>Phone: +40 746 540 029',
    accolades: allAccolades,
  },
  'calgary': {
    iso: 'us',
    location: 'Calgary',
    address: '700 2nd Street SW, Suite 2340<br/>Calgary, Alberta T2P 2W1, Canada',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'cape-town': {
    iso: 'za',
    location: 'Cape Town',
    address: '5th Floor, The Harrington<br/>50 Harrington St, District Six<br/>Cape Town, 7925',
    accolades: allAccolades,
  },
  'chennai':{
    iso: 'in',
    location: 'Chennai',
    address: 'COWRKS India Pvt Ltd, 5th Floor,<br/>Campus 3B Millenia Business Park,<br/>Phase 2, MGR Main Rd,<br/>Kandhanchavadi, Perungudi,<br/>Tamil Nadu 600096<br/>Chennai, India',
    accolades: indiaAccolades,
  },
  'chicago': {
    iso: 'us',
    location: 'Chicago',
    address: '35 W Wacker Drive<br/>Chicago, IL 60601',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'cleveland': {
    iso: 'us',
    location: 'Cleveland',
    address: '629 Euclid Avenue, 15th Floor<br/>Cleveland, OH 44114',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'cologne': {
    iso: 'de',
    location: 'Cologne',
    address: 'Sapient GmbH<br/>Cäcilienkloster 2<br/>50676 Köln, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'copenhagen': {
    iso: 'dk',
    location: 'Copenhagen',
    address: 'Vermundsgade 40A<br/>2100 Copenhagen, Denmark',
    accolades: allAccolades,
  },
  'denver': {
    iso: 'us',
    location: 'Denver',
    address: '11030 Circle Point Road<br/>Westminster, CO 80020',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'detroit': {
    iso: 'us',
    location: 'Detroit',
    address: '135 N. Old Woodward Avenue<br/>Birmingham, MI 48009',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'dubai': {
    iso: 'ae',
    location: 'Dubai',
    address: 'DMC Building 2<br/>Office 101 First Floor<br/>Dubai Media City<br/>Dubai, UAE',
    accolades: allAccolades,
  },
  'dusseldorf': {
    iso: 'de',
    location: 'Dusseldorf',
    address: 'Sapient GmbH<br/>Toulouser Allee 1<br/>40211 Düsseldorf, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'frankfurt': {
    iso: 'de',
    location: 'Frankfurt',
    address: 'Sapient GmbH<br/>Otto-Messmer-Straße 1<br/>60314 Frankfurt, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'gothenburg': {
    iso: 'se',
    location: 'Gothenburg',
    address: 'Kaserntorget 5, 411 18 Gothenburg, Sweden',
    accolades: allAccolades,
  },
  'gurgaon-unit-1': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 1)',
    address: 'Candor Techspace, Tower-A<br/>Building no. 2, Sector 21<br/>Old Delhi-Gurgaon Road<br/>Dundahera, Gurgaon - 122016 Haryana, India',
    accolades: indiaAccolades,
  },
  'gurgaon-unit-3': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 3)',
    address: 'Candor Techspace, Tower-B<br/>Building no. 8, Ground to 9th Floor, Sector 21<br/>Old Delhi - Gurgaon Road<br/>Dundahera, Gurgaon – 122016, Haryana, India',
    accolades: indiaAccolades,
  },
  'gurgaon-unit-4': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 4)',
    address: 'Candor Techspace, Tower-B<br/>Building no. 6, 6th to 9th Floor, Sector 21<br/>Old Delhi - Gurgaon Road<br/>Dundahera, Gurgaon – 122016, Haryana, India',
    accolades: indiaAccolades,
  },
  'hamburg': {
    iso: 'de',
    location: 'Hamburg',
    address: 'Sapient GmbH<br/>Heidi-Kabel-Platz 2<br/>20099 Hamburg, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'heredia':{
    iso: 'CR',
    location: 'Heredia',
    address: 'Eurocenter Building II, Third Floor.<br/>Heredia, Barreal, PO 40101<br/>Tel: +506 22098200',
    accolades: allAccolades,
  },
  'hong-kong': {
    iso: 'hk',
    location: 'Hong Kong',
    address: '6F AIA Kowloon Tower<br/>100 How Ming St<br/>Kwun Tong, Hong Kong',
    accolades: allAccolades,
  },
  'houston': {
    iso: 'us',
    location: 'Houston',
    address: '1111 Bagby St<br/>Suite 1950<br/>Houston, TX 77002',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'hyderabad': {
    iso: 'in',
    location: 'Hyderabad',
    address: 'Plot No 5 and 6, Block 4,<br/>5th Floor, Divya Sree Trinity,<br/>Hi-Tech City Layout, Madhapur,<br/>Hyderabad - 500081 , Telangana, India',
    accolades: indiaAccolades,
  },
  'iasi': {
    iso: 'ro',
    location: 'Iasi',
    address: 'Fab Lab,<br/>Strada Morilor 56,<br/>Iași 700011',
    accolades: allAccolades,
  },
  'irving': {
   iso: 'us',
   location: 'Irving',
   address: '6021 Connection Dr,<br/>Irving, TX 75039',
   disclaimer: disclaimersLabels.usa,
   accolades: allAccolades,
  },
  'johannesburg': {
    iso: 'za',
    location: 'Johannesburg',
    address: 'Building 1, Silver Stream Office Park<br/>10 Muswell Rd<br/>2194 Johannesburg',
    accolades: allAccolades,
  },
  'kolkata': {
    iso: 'in',
    location: 'Kolkata',
    address: '6th Floor, Street No. 13,<br/>DP Block, Sector V, Bidhannagar,<br/>Kolkata, West Bengal 700091, India',
    accolades: indiaAccolades,
  },
    'london': {
    iso: 'gb',
    location: 'London',
    address: 'Turnmill<br/>63 Turnmill Street<br />London, EC1M 5RR',
    accolades: allAccolades,
  },
  'los-angeles': {
    iso: 'us',
    location: 'Los Angeles',
    address: '13031 W Jefferson Blvd #800<br/>Los Angeles, CA 90094',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'malmo': {
    iso: 'se',
    location: 'Malmö',
    address: 'Brogatan 10<br/>211 44 Malmö, Sweden',
    accolades: allAccolades,
  },
  'melbourne': {
    iso: 'au',
    location: 'Melbourne',
    address: 'Level 7, 28 Freshwater Place<br/>Southbank, VIC 3006',
    accolades: allAccolades,
  },
  'méxico-city':{
    iso: 'MX',
    location: ' México City',
    address: 'Bosque de Duraznos 65,<br/>Bosque de las Lomas, Miguel Hidalgo,<br/>11700 Ciudad de México<br/>Tel: +52 55 9177 5600',
    accolades: allAccolades,
  },
  'miami-coconut-grove': {
    iso: 'us',
    location: 'Miami - Coconut Grove',
    address: '2911 Grand Avenue, Suite 100B<br/>Miami, FL 33133',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'miami-community': {
    iso: 'us',
    location: 'Miami - the community',
    address: '6400 Biscayne Blvd.<br/>Miami, FL 33138',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'milan': {
    iso: 'it',
    location: 'Milan',
    address: 'Via Bernina 34<br/>20158 Milano, Italy',
    accolades: allAccolades,
  },
  'mumbai': {
    iso: 'in',
    location: 'Mumbai',
    address: 'R-Tech Park, Goregaon(E)<br/>13th Floor, Building 2<br/>Off Western Express Highway<br/>Mumbai, Maharashtra - 400063, India',
    accolades: indiaAccolades,
  },
  'munich': {
    iso: 'de',
    location: 'Munich',
    address: 'Sapient GmbH<br/>Arnulfstraße 60<br/>80335 München, Germany',
    disclaimer: disclaimersLabels.germany,
    accolades: germanyAccolades,
  },
  'minneapolis': {
    iso: 'us',
    location: 'Minneapolis',
    address: '901 Marquette Ave, Floor 24<br/>Minneapolis, MN 55402 ',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'nancy': {
    iso: 'fr',
    location: 'Nancy',
    address: '14 Rue François de Neufchâteau<br/>54000 Nancy, France',
    accolades: allAccolades,
  },
  'new-york': {
    iso: 'us',
    location: 'New York',
    address: '375 Hudson Street, 9th Floor<br/>New York, NY 10014',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'noida': {
    iso: 'in',
    location: 'Noida',
    address: 'Tower C, Ground Floor to 4th Floor<br/>IT/ ITES SEZ, Plot No. 7, Sector -144, Noida, Distt. G. B. Nagar (U.P.), India',
    accolades: indiaAccolades,
  },
  'noida-candor': {
    iso: 'in',
    location: 'Noida Candor',
    address: '12th Floor, Candor Tech Space, Building No. 5<br/>IT / ITES SEZ, Seaview Developers Pvt. Ltd.<br/>Plot No. 20 & 21, Sector -135, Noida, India',
    accolades: indiaAccolades,
  },
  'oman':{
    iso: 'om',
    location: 'Oman',
    address: 'Publicis Muscat SPC<br/>7th Floor, Al Fardan Building<br/>724-56 Ghala Heights<br/>Muscat, Sultanate of Oman',
    accolades: allAccolades,
  },
  'paris': {
    iso: 'fr',
    location: 'Paris',
    address: '145 rue de Courcelles<br/>75017 Paris, France',
    accolades: allAccolades,
  },
  'portland': {
    iso: 'us',
    location: 'Portland',
    address: '1330 NW 14th Avenue<br/>Portland, OR 97209',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'riyadh': {
    iso: 'sa',
    location: 'Riyadh',
    address: 'Faisaliah Tower, 9th floor<br/>Riyadh 11351, P.O. Box 295797,<br/>Olaya Road, KSA',
    accolades: allAccolades,
  },
  'san-francisco': {
    iso: 'us',
    location: 'San Francisco',
    address: '350 Bush Street, Floor 17<br/>San Francisco, CA 94104',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'san-jose': {
    iso: 'us',
    location: 'San Jose',
    address: '1 Almaden Avenue, Suite 650<br/>San Jose, CA 95113',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'san-luis-obispo': {
    iso: 'us',
    location: 'San Luis Obispo',
    address: '4800 Morabito Place<br/>San Luis Obispo, CA 93401',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'seattle': {
    iso: 'us',
    location: 'Seattle',
    address: '424 2nd Avenue West<br/>Seattle, WA 98119',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'shanghai': {
    iso: 'cn',
    location: 'Shanghai',
    address: '19/F, Henderson 688 Plaza<br/>No. 688 West Nanjing Road, Jingan District<br/>Shanghai, China 200041',
    accolades: allAccolades,
  },
  'singapore': {
    iso: 'sg',
    location: 'Singapore',
    address: '120 Beach Road<br/>Guoco Midtown House<br/>Level 3, Unit 01</br>Singapore 189769',
    accolades: allAccolades,
  },
  'stockholm': {
    iso: 'se',
    location: 'Stockholm',
    address: 'Lumaparksvägen 7, 8tr<br/>120 31 Stockholm, Sweden',
    disclaimer: disclaimersLabels.stockholm,
    accolades: allAccolades,
  },
  'sydney': {
    iso: 'au',
    location: 'Sydney',
	address: 'Level 3, 21 Harris Street,<br/>Pyrmont,<br/>Sydney 2009 NSW, Australia',
    accolades: allAccolades,
  },
  'timisoara': {
      iso: 'ro',
      location: 'Timisoara',
      address: 'Calea Aradului<br/>no.11, 3rd floor<br/>Timisoara 300254',
      accolades: allAccolades,
    },
  'tokyo': {
    iso: 'jp',
    location: 'Tokyo',
    address: 'JR Tokyu Meguro Building<br/>3-1-1 Kami-Osaki, Shinagawa-ku<br/>Tokyo 141-0021, Japan',
    accolades: allAccolades,
  },
  'toronto': {
    iso: 'us',
    location: 'Toronto',
    address: '134 Peter Street,12th Floor<br/>Toronto, ON M5V 2H2',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'turin': {
    iso: 'it',
    location: 'Turin',
    address: 'Via Santa Teresa, 12<br/>10121 Turin, Italy',
    accolades: allAccolades,
  },
  'washington': {
    iso: 'us',
    location: 'Washington D.C. - Arlington ',
    address: '1515 North Courthouse Road, 4th Floor<br/>Arlington, VA 22201',
    disclaimer: disclaimersLabels.usa,
    accolades: allAccolades,
  },
  'zurich': {
    iso: 'ch',
    location: 'Zurich',
    address: 'Sapient Switzerland GmbH<br/>Stadelhoferstrasse 25<br/>8001 Zürich, Switzerland',
    disclaimer: disclaimersLabels.zurich,
    accolades: allAccolades,
  },
};

export default officeLabels;



// WEBPACK FOOTER //
// ./src/labels/offices.js